import { render } from "./PlayingCard.vue?vue&type=template&id=525aa6f6&scoped=true"
import script from "./PlayingCard.vue?vue&type=script&lang=js"
export * from "./PlayingCard.vue?vue&type=script&lang=js"

import "./PlayingCard.vue?vue&type=style&index=0&id=525aa6f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525aa6f6"]])

export default __exports__